var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg63(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "642px",
    viewBox: "0 0 104 642",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.33,585.31 C193.78,171.65 7.35,4.54747351e-13 7.35,4.54747351e-13",
    id: "Path",
    stroke: "#FFCF02",
    strokeWidth: 6.99,
    strokeDasharray: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 582.030000)",
    fill: "#FFCF02"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 4.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.22,44.9 C13.39,44.9 4.94,38.21 2.69,28.62 C1.4,23.13 2.32,17.47 5.29,12.67 C8.26,7.88 12.91,4.52 18.4,3.23 C19.99,2.85 21.63,2.66 23.25,2.66 C33.08,2.66 41.52,9.35 43.78,18.94 C46.45,30.27 39.4,41.66 28.07,44.32 C26.48,44.7 24.84,44.89 23.22,44.89 L23.22,44.9 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg63);
export default __webpack_public_path__ + "static/media/63.ef812e782b29686c4f504bec3917913a.svg";
export { ForwardRef as ReactComponent };